<div class="modal-header">
    <button type="button" class="btn-close" mat-dialog-close></button>
</div>
<div class="modal-body">
    <iframe id="pdf" name="pdf" width="95%" height="500px" [src]="getSourceURL(fileUrl)"></iframe>
</div>


